<template>
  <div>
    <nav class="nav-bar">
      <router-link to="/" class="home-link">
        <img src="@/assets/home.svg" alt="Home" />
      </router-link>
    </nav>
    <iframe class="show-view" :key="iframeKey" :src="fileName" @load="onIframeLoad"></iframe>
  </div>
  <!-- 在 iframe 上绑定一个 :key，当 key 改变时，iframe 会被重新创建 -->
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const filePath = route.query.filePath

// 用来控制 iframe 重载的 key
const iframeKey = ref(0)

const fileName = computed(() => {
  const name = filePath?.split('_')[0]
  console.log(`http://test.ce-safe.com:59701/offline.html?m=${name}#/`, 999999)

  return `http://test.ce-safe.com:59701/offline.html?m=${name}#/`
})

// 监听 filePath 的变化，如果有变化则更新 iframeKey，从而强制重载 iframe
watch(
  () => filePath,
  () => {
    iframeKey.value++
  }
)

// iframe 加载完成的回调，可选
function onIframeLoad() {
  console.log('Iframe 加载完成')
}
</script>

<style scoped lang="scss">
.show-view {
  width: 100%;
  height: calc(100vh - 51px);
  border: none;
}
.nav-bar {
  display: flex;
  align-items: center;
  background-color: #4a4c51;
  padding: 3px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  .home-link {
    color: white;
    text-decoration: none;
    font-size: 24px;
    margin: 0 20px 0 10px;
    &:hover {
      color: #dfe3ee;
    }
  }

.nav-link {
    color: white;
    text-decoration: none;
    padding: 10px 20px;
    margin: 0 10px;
    border-radius: 5px;
    transition:
    background-color 0.3s,
    color 0.3s;

    &:hover {
        background-color: #2d4373;
    }

    &.active {
        background-color: #2d4373;
    }
}
.upload-button {
    margin-left: auto;
}
}
</style>
